import React from "react";
import { Link } from "react-router-dom";

const blogItem = ({
  posts: { title, content, contentTitle, img, link, repolink }
}) => {
  // const { title, content, contentTitle, img, link, repolink } = posts;
  console.log(
    " title, content, contentTitle, img, link, repolink",
    title,
    content,
    contentTitle,
    img,
    link,
    repolink
  );

  return (
    <div className="card">
      <h1>
        ıbeat<span>u</span>
      </h1>
      <h2>{title}</h2>
      <div className="card-content">
        <img src={img[0]}></img>
        {img[1] && <img src={img[1]}></img>}
        <div className="card-readme">
          <h3>{contentTitle}</h3>
          <p>{content}</p>
          <p>
            ▶{" "}
            <a href={link} target="_blank">
              <span>Live Demo</span>
            </a>
          </p>
        </div>
      </div>
      <button type="submit">
        {" "}
        <a href={repolink} target="_blank">
          Go to github repo
        </a>
      </button>
    </div>
  );
};

export default blogItem;
